import { PostOrPatchUserDto, ZitadelUser } from "@src/types/user-management";

export const buildRequestObjectForUser = (
  user: Partial<ZitadelUser>,
): PostOrPatchUserDto => {
  return {
    email: user.email,
    username: user.username,
    given_name: user.given_name,
    family_name: user.family_name,
    language: user.language,
    chosen_timezone: user.chosen_timezone ?? "UTC",
    roles: user.roles,
  };
};
